import { ApolloClient } from 'apollo-client'
import {
  InMemoryCache,
  defaultDataIdFromObject,
  IntrospectionFragmentMatcher,
} from "apollo-cache-inmemory"
import { HttpLink } from 'apollo-link-http'
import { onError } from 'apollo-link-error'
import { setContext } from 'apollo-link-context'
import { ApolloLink } from 'apollo-link'
import store from './store'
import introspectionQueryResultData from '../graphql/generated/schema-legacy.json'
import { setToken } from '../actions/auth'
import { setCrSection, setCrReportIds, setFilters } from '../actions/survey'
import { getBackendUrl, getSecondaryBackendUrl, getCookie, setCookie } from '../utilities/helpers'

const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData,
})

export const configureClient = () => {
  return new ApolloClient({
    link: ApolloLink.from([
      setContext((request, previousContext) => {
        let token = store.getState().auth.token;
        const surveyId = request.variables.surveyId;

        if (surveyId) {
          // If we don't have the token in session storage we check if it's in a cookie or local storage and then set it to session storage
          // In this case the user opens the bookmark to a new tab
          if(!token) {
            // Store the token into a cookie
            token = getCookie(surveyId);

            // Update the cookie
            if (token) {
              setCookie(surveyId, token, 60);
            }
            store.dispatch(setToken(token));
          }

          // If the user tries to open another survey on top of another in same tab from a bookmark
          if ((token && getCookie(surveyId) !== undefined) && (getCookie(surveyId) !== token)) {
            console.log("Changing survey");
            token = getCookie(surveyId);
            // Reset the survey specific store values
            store.dispatch(setToken(token));
            store.dispatch(setCrSection("overall"));
            store.dispatch(setCrReportIds({ themeId: null, driverId: null, statementId: null }));
            store.dispatch(setFilters([]));
          }
        }

        if (!token || request.operationName === "OpenQuestionnaire") return

        return {
          headers: { Authorization: `Bearer ${token}` },
        }
      }),
      onError(({ graphQLErrors, networkError }) => {
        if (graphQLErrors)
          graphQLErrors.map(({ message, locations, path }) =>
            console.log(
              `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
            )
          );
        if (networkError) console.log(`[Network error]: ${networkError}`)
      }),
      new HttpLink({
        uri: getBackendUrl(),
        credentials: "same-origin",
      }),
    ]),
    cache: new InMemoryCache({ 
      dataIdFromObject: (object) => {
        const { __typename } = object;
        // SurveyStatistics*EntryOutput: surveys in a sequence share theme/driver/question IDs,
        // so normalizing by ID would cause one survey's statistics to overwrite another's.
        if (
          __typename === "RespondentOption" ||
          __typename === "AfterGameQuestionStatistics" ||
          __typename === "AfterGameCatalystStatistics" ||
          __typename === "AfterGameDetailedDriverStatistics" ||
          __typename === "SurveyStatisticsThemeEntryOutput" ||
          __typename === "SurveyStatisticsDriverEntryOutput" ||
          __typename === "SurveyStatisticsQuestionEntryOutput"
        ) {
          return null;
        }
        return defaultDataIdFromObject(object)
      },
      fragmentMatcher
    }),
  });
};

let secondaryClient

export const getSecondaryClient = () => {
  if (!secondaryClient) {
    throw new Error('getSecondaryClient called before configureSecondaryClient')
  }
  return secondaryClient
}

export const configureSecondaryClient = () => {
  secondaryClient = new ApolloClient({
    link: ApolloLink.from([
      setContext(() => {
        const token = store.getState().auth.token
        if (!token) return
        return { headers: { Authorization: `Bearer ${token}` } }
      }),
      onError(({ networkError }) => {
        if (networkError) console.log(`[Network error]: ${networkError}`)
      }),
      new HttpLink({ uri: getSecondaryBackendUrl(), credentials: 'same-origin' })
    ]),
    cache: new InMemoryCache()
  })
  return secondaryClient
}



// WEBPACK FOOTER //
// ./src/data/client.js